<script>
  import { format } from 'svelte-i18n';

  import { Field, FieldActions, FieldHeader, FieldLabel, FieldValue } from '@client/components/fields/standalone/base';
  import { Select } from '@client/components/select';

  export let id = null;
  export let label = null;
  export let selected = null;
  export let options = [];
  export let value = null;
  export let clearable = false;
  export let searchable = false;
  export let showChevron = true;
  export let placeholder = $format('label.PLACEHOLDER.SELECT');
  export let filterText = '';
  export let itemFilter = (label, filterText, option) => `${label}`.toLowerCase().includes(filterText.toLowerCase());
  export let formatValue = (selected) => $format(selected?.label) || '-';

  export let tooltip = undefined;
  export let tooltipIcon = undefined;

  export let readonly = false;
  export let editing = false;

  export let showActions = true;

  export let onChange = () => {};
  export let onUpdate = () => {};

  let items = [...options];
  let selectedValue = selected ? { ...selected } : selected;
  let disableSubmit = true;

  const onEdit = () => {
    editing = true;
  };

  const onCancel = () => {
    editing = false;
    selectedValue = selected;
  };

  const onSave = () => {
    editing = false;
    value = selectedValue.value;

    if (onUpdate) {
      onUpdate(id, label, selectedValue);
    }
  };

  const onClear = () => {
    selectedValue = null;
  };

  const onSelect = ({ detail = {} }) => {
    selectedValue = detail;
    onChange(detail);
  };

  $: selectedValue = selected ? { ...selected } : selected;
  $: items = [...options];
  $: disableSubmit = JSON.stringify(selectedValue) === JSON.stringify(selected);
</script>

<Field bind:editing>
  <FieldHeader>
    <FieldLabel {label} {tooltipIcon} {tooltip} />
    <FieldActions bind:readonly bind:editing bind:disableSubmit {onSave} {onEdit} {onCancel} {showActions} />
  </FieldHeader>
  <FieldValue {showActions}>
    <span class="field-select" data-testid="field-select">
      {#if editing}
        <Select
          bind:items
          value={$format(selectedValue.label)}
          on:change={onSelect}
          on:clear={onClear}
          on:filter
          bind:filterText
          {itemFilter}
          {showChevron}
          {clearable}
          {searchable}
          {placeholder}
          {...$$restProps}
        >
          <slot name="item" slot="item" let:item {item}>
            {$format(item.label)}
          </slot>
          <slot name="empty" slot="empty">
            <div class="empty">{$format('label.NO_OPTIONS_AVAILABLE')}</div>
          </slot>
        </Select>
      {:else}
        {formatValue(selected)}
      {/if}
    </span>
  </FieldValue>
  {#if !editing}
    <slot />
  {/if}
</Field>

<style lang="scss" src="./select.scss"></style>
